webpackJsonp([84336607365395,172827162754877,130293295582874],{

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _SimpleTextArea = __webpack_require__(197);
	
	var _SimpleTextArea2 = _interopRequireDefault(_SimpleTextArea);
	
	var _InvalidTextArea = __webpack_require__(196);
	
	var _InvalidTextArea2 = _interopRequireDefault(_InvalidTextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'TextArea',
	  components: {
	    TextArea: _reactCore.TextArea
	  },
	  examples: [{ component: _SimpleTextArea2.default, title: 'Simple TextArea' }, { component: _InvalidTextArea2.default, title: 'Invalid TextArea' }]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvalidTextArea = function (_React$Component) {
	  _inherits(InvalidTextArea, _React$Component);
	
	  function InvalidTextArea() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InvalidTextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      value: ''
	    }, _this.handleInvalidTextAreaChange = function (value) {
	      _this.setState({ value: value });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  InvalidTextArea.prototype.render = function render() {
	    var value = this.state.value;
	
	
	    return _react2.default.createElement(_reactCore.TextArea, {
	      value: value,
	      onChange: this.handleInvalidTextAreaChange,
	      isRequired: true,
	      isValid: false,
	      'aria-label': 'invalid text area example'
	    });
	  };
	
	  return InvalidTextArea;
	}(_react2.default.Component);
	
	exports.default = InvalidTextArea;
	InvalidTextArea.__docgenInfo = {
	  'description': '',
	  'displayName': 'InvalidTextArea'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { TextArea } from '@patternfly/react-core';\n\nclass InvalidTextArea extends React.Component {\n  state = {\n    value: ''\n  };\n\n  handleInvalidTextAreaChange = value => {\n    this.setState({ value });\n  };\n\n  render() {\n    const { value } = this.state;\n\n    return (\n      <TextArea\n        value={value}\n        onChange={this.handleInvalidTextAreaChange}\n        isRequired\n        isValid={false}\n        aria-label=\"invalid text area example\"\n      />\n    );\n  }\n}\n\nexport default InvalidTextArea;\n"

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleTextArea = function (_React$Component) {
	  _inherits(SimpleTextArea, _React$Component);
	
	  function SimpleTextArea() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SimpleTextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      value: ''
	    }, _this.handleTextAreaChange = function (value) {
	      _this.setState({ value: value });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SimpleTextArea.prototype.render = function render() {
	    var value = this.state.value;
	
	
	    return _react2.default.createElement(_reactCore.TextArea, { value: value, onChange: this.handleTextAreaChange, 'aria-label': 'text area example' });
	  };
	
	  return SimpleTextArea;
	}(_react2.default.Component);
	
	exports.default = SimpleTextArea;
	SimpleTextArea.__docgenInfo = {
	  'description': '',
	  'displayName': 'SimpleTextArea'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { TextArea } from '@patternfly/react-core';\n\nclass SimpleTextArea extends React.Component {\n  state = {\n    value: ''\n  };\n\n  handleTextAreaChange = value => {\n    this.setState({ value });\n  };\n\n  render() {\n    const { value } = this.state;\n\n    return <TextArea value={value} onChange={this.handleTextAreaChange} aria-label=\"text area example\" />;\n  }\n}\n\nexport default SimpleTextArea;\n"

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.textarea_package = exports.textarea_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextAreaDocs = __webpack_require__(547);
	
	var _TextAreaDocs2 = _interopRequireDefault(_TextAreaDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'InvalidTextArea', path: '../../react-core/src/components/TextArea/examples/InvalidTextArea.js', file: __webpack_require__(442) }, { name: 'SimpleTextArea', path: '../../react-core/src/components/TextArea/examples/SimpleTextArea.js', file: __webpack_require__(443) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var textarea_docs = exports.textarea_docs = _TextAreaDocs2.default;
	var textarea_package = exports.textarea_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _TextAreaDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-text-area-docs-js-70f32bb74cb7201be85a.js